import { Model } from '@vuex-orm/core'
import { Request } from '@vuex-orm/plugin-axios'
import Extra from '@/models/Extra'
import RatePlanPrice from '@/models/RatePlanPrice'
import Theme from '@/models/Theme'
import { getCode } from '@/lang'
import AppState from '@/utils/app.state'
import { LangedItem } from './common/commons'

export default class Room extends Model {
  declare id: number
  declare name?: LangedItem[]
  declare type?: string
  declare ratePlanPrices: RatePlanPrice[]
  declare extras: Extra[]
  declare themes: Theme[] // via Extra
  declare internalName?: string

  static entity = 'rooms'

  static fields() {
    return {
      id: this.number(0),
      name: this.attr(null).nullable(),
      type: this.string(null).nullable(),
      ratePlanPrices: this.hasMany(RatePlanPrice, 'roomID'),
      extras: this.hasMany(Extra, 'extraID'),
      themes: this.hasManyThrough(Theme, Extra, '', ''),
      internalName: this.attr(null).nullable()
    }
  }

  get langedName() {
    const name = this.name
    return (name && name.length && name[0].value) || ''
  }

  static apiConfig = {
    dataTransformer: (response: { data: any }) => {
      return response.data
    },

    actions: {
      fetch(this: Request) {
        return this.post(
          '/content/v2/rooms/getbypropertyids',
          {
            propertyIDs: [AppState.currentProperty],
            getImages: false,
            getAmenities: false,
            getDescriptions: true, // needed for name in analytics
            languageCodes: [getCode()]
          }
        )
      }
    }
  }
}
